/**
 * M10 Notification preferences REST client.
 */

import { env } from '@/lib/env';
import { ApiError, type ProblemDetail } from '@/features/auth/api';
import { useAuthStore } from '@/stores/auth-store';

export type NotificationPreferences = {
  channels: string[];
  categories: string[];
  preferences: Record<string, Record<string, boolean>>;
};

async function call<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = useAuthStore.getState().accessToken;
  const url = `${env.VITE_API_URL}/api/v1${path}`;
  const headers = new Headers(init.headers ?? {});
  headers.set('Accept', 'application/json');
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const res = await fetch(url, { ...init, headers });
  if (res.status === 204) return undefined as T;
  const text = await res.text();
  const data = text ? JSON.parse(text) : undefined;
  if (!res.ok) {
    const problem: ProblemDetail = (data?.error ?? data) || {
      detail: `HTTP ${res.status}`,
    };
    throw new ApiError(res.status, problem);
  }
  return data as T;
}

export const notifPrefsApi = {
  get: () => call<NotificationPreferences>('/me/notification-preferences'),
  put: (preferences: Record<string, Record<string, boolean>>) =>
    call<NotificationPreferences>('/me/notification-preferences', {
      method: 'PUT',
      body: JSON.stringify({ preferences }),
    }),
};
